import { Typography } from "@mui/material";

interface SingleStoryRequirementsProps {
  hasMissingRequirements: boolean;
  canGenerateAI: boolean;
  alreadyInCollection: boolean;
  isSaving: boolean;
}

export const SingleStoryRequirements = ({
  hasMissingRequirements,
  canGenerateAI,
  alreadyInCollection,
  isSaving,
}: SingleStoryRequirementsProps) => (
  <>
    {hasMissingRequirements && !canGenerateAI && (
      <Typography sx={{ color: "#C94343", fontSize: "12px", lineHeight: "18px" }}>Transcript required</Typography>
    )}
    {alreadyInCollection && !isSaving && (
      <Typography sx={{ color: "#C94343", fontSize: "13px", lineHeight: "20px" }}>
        This story is already in the selected collection.
      </Typography>
    )}
  </>
);
